/** @owner @Appboy/ai-decisioning-experience */

import type {
  DecisioningCreativeComponentLiquidContextStruct,
  DecisioningCreativeComponentName,
  DecisioningCreativeComponentSelections,
  DecisioningCreativeComponentVariantsByComponent,
} from "../types";

/** Stable empty refs for inactive / default DS liquid context (avoid per-render `{}` / `[]`). */
export const emptyDecisioningCreativeComponentUsedComponents: DecisioningCreativeComponentName[] = [];
export const emptyDecisioningCreativeComponentVariantsByComponent: DecisioningCreativeComponentVariantsByComponent =
  {};
export const emptyDecisioningCreativeComponentSelections: DecisioningCreativeComponentSelections = {};

export const defaultDecisioningCreativeComponentLiquidContextStruct: DecisioningCreativeComponentLiquidContextStruct =
  {
    isDecisioningStudioCampaign: false,
    usedComponents: emptyDecisioningCreativeComponentUsedComponents,
    variantsByComponent: emptyDecisioningCreativeComponentVariantsByComponent,
    selections: emptyDecisioningCreativeComponentSelections,
  };
